import { render, staticRenderFns } from "./DocumentTemplate.vue?vue&type=template&id=86458d28"
import script from "./DocumentTemplate.vue?vue&type=script&lang=js"
export * from "./DocumentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports